var map = {
	"./5-affissione-classica-01.png": 1210,
	"./5-affissione-classica-02.png": 1211,
	"./8-arredo-urbano-01.png": 1212,
	"./8-arredo-urbano-02.png": 1213,
	"./9-others-01.png": 1214,
	"./9-others-02.png": 1215,
	"./Airport_FA541C.png": 1216,
	"./Airport_FA541C_selected.png": 1217,
	"./Default_8C8C8C.png": 1218,
	"./Default_8C8C8C_selected.png": 1219,
	"./Downtown_434343.png": 1220,
	"./Downtown_434343_selected.png": 1221,
	"./Highway_1890FF.png": 1222,
	"./Highway_1890FF_selected.png": 1223,
	"./Malls_CF1322.png": 1224,
	"./Malls_CF1322_selected.png": 1225,
	"./Pharma_52C41A.png": 1226,
	"./Pharma_52C41A_selected.png": 1227,
	"./Station_1D39C4.png": 1228,
	"./Station_1D39C4_selected.png": 1229,
	"./Subway_722ED1.png": 1230,
	"./Subway_722ED1_selected.png": 1231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 590;